// extracted by mini-css-extract-plugin
export default {"canvas":"invitationCard_canvas__tkRx7"};